<div *ngIf="ready">
  <common-animated-svg
    [svgName]="'success'"
    [delayMs]="200"
    [height]="45"
    [width]="46"
    [loop]="false"></common-animated-svg>
  <h1 [innerHTML]="text"></h1>
</div>
